/**
 * Closes the browser in the mobile app
 */
export const notifyMobileApp = () => {
  const message = { type: "upgradeSuccess", message: "close" };

  if (window.webkit) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  } else {
    window.postMessage(JSON.stringify(message), "*");
  }
};
